import React from 'react';
import PropTypes from 'prop-types';
import ResourceSvg from '../location/ResourceSvg';
import {locationPropTypes} from '../models/location';
import BookingBox from "./BookingBox";
import NotifyBox from "./NotifyBox";
import {TranslationContext} from "../translations/context";

const GenericResourceSelector = (props) => {
    const [selectedResource, setSelectedResource] = React.useState(null);
    const {location, apiBackend, locationSlug} = props;
    const {t} = React.useContext(TranslationContext);

    const updateSelectedResource = (resource_id) => {
        const newSelectedResource = location.resources.filter(resource => resource.id === resource_id);
        if (!newSelectedResource.length) {
            setSelectedResource(null);
        } else {
            setSelectedResource(newSelectedResource[0]);
        }
    };

    const has_free_box = location.resources.filter(resource => resource.status === 'free').length > 0;

    return <div>
        <h2 className="column is-12">{location.name} {t('booking')}</h2>
        <div className="columns control">
            <div className="column is-6">
                {has_free_box && <BookingBox
                    location={location}
                    apiBackend={apiBackend}
                    selectedResource={selectedResource}
                    updateSelectedResource={updateSelectedResource}
                />}
                {!has_free_box && <NotifyBox
                    location={location}
                />}
                {!!location.description && <div className="block">
                    {location.description}
                </div>}
            </div>
            <div className="column is-6">
                <ResourceSvg
                    apiBackend={apiBackend}
                    locationSlug={locationSlug}
                    selectedResource={selectedResource}
                    updateSelectedResource={updateSelectedResource}
                />
            </div>
        </div>
    </div>;
};

GenericResourceSelector.propTypes = {
    location: PropTypes.shape(locationPropTypes).isRequired,
    apiBackend: PropTypes.string.isRequired,
    locationSlug: PropTypes.string.isRequired,
};

export default GenericResourceSelector;
